/**
 * Resolve Messages stack view from pathname.
 * List → /messages · New → /messages/new · Thread → /messages/:id
 */

export function getMessagesView(pathname = '') {
  const path = String(pathname || '').replace(/\/+$/, '') || '/messages';

  if (path === '/messages/new') {
    return { view: 'new', conversationId: null };
  }

  const threadMatch = path.match(/^\/messages\/([^/]+)$/);
  if (threadMatch && threadMatch[1] !== 'new') {
    return { view: 'thread', conversationId: String(threadMatch[1]) };
  }

  return { view: 'list', conversationId: null };
}

export function messagesListPath() {
  return '/messages';
}

export function messagesNewPath() {
  return '/messages/new';
}

export function messagesThreadPath(conversationId) {
  return `/messages/${conversationId}`;
}

/** Normalize API / list conversation ids for routing + comparisons. */
export function getConversationRouteId(conversation) {
  if (conversation == null) return null;
  if (typeof conversation === 'object') {
    const id = conversation.id ?? conversation.conversation?.id;
    return id == null ? null : String(id);
  }
  return String(conversation);
}
